<template>
    <el-dialog :title="title" :visible.sync="dialogTableVisible" @close="closeDialog" width="80%" top="5vh">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(item, key) in active_list" :key="key" :label="item.label" :name="item.value"></el-tab-pane>
        </el-tabs>

        <el-form ref="form" :inline="true" :model="searcheModel">
            <el-form-item label="下载时间">
                <el-date-picker
                    size="small"
                    v-model="searcheModel.created_at"
                    type="daterange"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="学段筛选">
                <el-select size="small" v-model="searcheModel.stage" placeholder="请选择">
                    <el-option v-for="(item, key) in stages" :key="key" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="科目筛选">
                <el-select size="small" v-model="searcheModel.subject_id" placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option v-for="(item, key) in subjects" :key="key" :label="item.subject_name" :value="item.subject_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="类型" v-if="activeName == 'xwt'">
                <el-select size="small" v-model="searcheModel.asset_type" placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option label="普通" value="0"></el-option>
                    <el-option label="精品" value="1"></el-option>
                    <el-option label="特供" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                <el-button @click="resetForm()" size="small">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="list" height="550" v-loading="loading" :key="1" v-if="activeName == 'zj'">
            <el-table-column property="user" label="用户ID"></el-table-column>
            <el-table-column property="username" label="用户名"></el-table-column>
            <el-table-column property="real_name" label="真实姓名"></el-table-column>
            <el-table-column property="school_name" label="所在学校"></el-table-column>
            <el-table-column property="pid" label="组卷ID"></el-table-column>
            <el-table-column label="学段学科">
                <template slot-scope="scope">
                    <span v-for="(item, index) in stages" v-show="item.value == scope.row.xd">
                        {{item.label}}
                    </span>
                    /
                    <span v-for="(item, index) in subjects" v-show="item.subject_id == scope.row.chid">
                        {{item.subject_name}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column property="title" label="资料标题"></el-table-column>
            <el-table-column label="用户类型">
                <template slot-scope="scope">
                    {{user_types[scope.row.usertype]}}
                </template>
            </el-table-column>
            <el-table-column property="questions_num" label="试题数"></el-table-column>
            <el-table-column property="ip" label="下载IP"></el-table-column>
            <el-table-column property="downtime" label="下载时间"></el-table-column>
        </el-table>

        <el-table :data="list" height="550" v-loading="loading" :key="2" v-if="activeName == 'xwt'">
            <el-table-column property="uid" label="用户ID"></el-table-column>
            <el-table-column property="username" label="用户名"></el-table-column>
            <el-table-column property="real_name" label="真实姓名"></el-table-column>
            <el-table-column property="customer_name" label="所在学校"></el-table-column>
            <el-table-column property="asset_id" label="资料ID"></el-table-column>
            <el-table-column property="title" label="资料标题"></el-table-column>
            <el-table-column label="学段学科">
                <template slot-scope="scope">
                    <span v-for="(item, index) in stages" v-show="item.value == scope.row.stage">
                        {{item.label}}
                    </span>
                    /
                    <span v-for="(item, index) in subjects" v-show="item.subject_id == scope.row.subject_id">
                        {{item.subject_name}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column property="group_id" label="车厢ID"></el-table-column>
            <el-table-column property="ip" label="下载IP"></el-table-column>
            <el-table-column property="asset_type_name" label="类型"></el-table-column>
            <el-table-column property="created_at" label="下载时间"></el-table-column>
        </el-table>
        <el-row style="text-align: center;">
            <MyPagination :linkPage="linkPage" @size-change="handleSizeChange" @current-change="handleCurrentChange"></MyPagination>
        </el-row>
    </el-dialog>
</template>
<script>
    import Log from "~/services/log";
    import MyPagination from "~/widgets/MyPagination.vue";
    import Config from "~/config/params";
    export default {
        props:{
            params:{
                type: Object,
                required: true,
            },
            title:{
                type: String,
                required: false,
                default: '下载日志'
            },
        },
        components: {
            MyPagination
        },
        data(){
            return {
                list:[],
                loading: false,
                dialogTableVisible: true,
                linkPage: null,
                activeName: 'zj',
                active_list: [
                    {
                        label: '组卷',
                        value: 'zj',
                    },
                    {
                        label: '校网通|校本3',
                        value: 'xwt',
                    },
                ],
                searcheModel: {},
                stages: [],
                subjects: [],
                user_types: {
                    0: '普通用户',
                    1: '学校用户',
                    2: 'VIP用户',
                },
            }
        },
        created() {
            this.stages = Config.getStages();
            this.subjects = Config.getSubjects();
            this.resetForm();
        },
        methods: {
            //重置按钮
            resetForm() {
                this.searcheModel = {
                    created_at: '',
                    stage: '',
                    subject_id: '',
                    asset_type: '',
                };
                this.list = [];
                this.linkPage = null;
                this.submitSearch();
            },

            // 筛选查询
            submitSearch($data = null) {
                if($data && typeof $data.order !== undefined){
                    this.searcheModel.sort_name = $data['prop'];
                    this.searcheModel.sort_by = $data['order'];
                }
                let params = _.clone(this.searcheModel);
                params['page'] = 1;
                _.each(params, (val, key) => {
                    // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                    if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                        delete params[key];
                    }
                })
                this.getList(params);
            },

            //获取列表
            getList() {
                // loading 动画
                this.loading = true;
                let service = null;
                if(this.activeName == 'zj'){
                    service = Log.zj_down_log(this.params);
                }else{
                    service = Log.index(this.params);
                }
                
                service.then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                    }
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                })
                .catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
            },

            handleView(row) {
                let routeData = this.$router.resolve({
                    path: "/order/view",
                    query: { id: row.order_id },
                });
                window.open(routeData.href, '_blank');
            },

            handleSizeChange(newSize) {
                // 处理每页条目数变化事件
                let params = this.params;
                params['perPage'] = newSize;
                this.getList(params);
            },

            handleCurrentChange(newPage) {
                let params = this.params;
                // 处理当前页码变化事件
                params['page'] = newPage;
                this.getList(params);
            },
            
            closeDialog(){
                this.dialogTableVisible = false;
                this.$emit("close", []);
            },

            handleClick(tab, event) {
                this.resetForm();
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/public_acc/downLogDialog.vue